import React, { useState } from 'react';
import { MapPinIcon, ChevronDownIcon, ChevronUpIcon, StarIcon } from 'lucide-react';
import { LocationPost } from './LocationPost';
import { Badge } from '../ui/Badge';
type LocationGroupProps = {
  location: {
    name: string;
    distance: string;
    postCount: number;
    rating?: number;
  };
  posts: any[];
};
export const LocationGroup: React.FC<LocationGroupProps> = ({
  location,
  posts
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return <div className="mb-6" data-id="element-57">
      <div className={`flex items-center justify-between bg-white rounded-xl shadow-sm p-4 border border-gray-100 mb-2 cursor-pointer transition-all ${isExpanded ? 'border-primary/30 bg-primary/5 shadow-md' : 'hover:border-primary/20 hover:bg-gray-50'}`} onClick={() => setIsExpanded(!isExpanded)} data-id="element-58">
        <div className="flex items-center" data-id="element-59">
          <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center mr-3 text-primary" data-id="element-60">
            <MapPinIcon size={20} data-id="element-61" />
          </div>
          <div data-id="element-62">
            <div className="flex items-center" data-id="element-63">
              <h3 className="font-medium" data-id="element-64">{location.name}</h3>
              {location.rating && <div className="flex items-center ml-2" data-id="element-65">
                  <div className="flex" data-id="element-66">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} size={12} className={i < Math.floor(location.rating!) ? 'text-yellow-500 fill-yellow-500' : 'text-gray-300'} data-id="element-67" />)}
                  </div>
                  <span className="ml-1 text-xs" data-id="element-68">{location.rating}</span>
                </div>}
            </div>
            <p className="text-sm text-gray-500" data-id="element-69">
              {location.distance} away • {location.postCount} posts
            </p>
          </div>
        </div>
        <div className="flex items-center" data-id="element-70">
          <Badge variant={isExpanded ? 'primary' : 'secondary'} className="mr-2" data-id="element-71">
            {location.postCount} posts
          </Badge>
          <div className={`flex items-center justify-center w-7 h-7 rounded-full transition-colors ${isExpanded ? 'bg-white text-primary shadow-sm' : 'text-gray-500 hover:bg-gray-100'}`} data-id="element-72">
            {isExpanded ? <ChevronUpIcon size={18} data-id="element-73" /> : <ChevronDownIcon size={18} data-id="element-74" />}
          </div>
        </div>
      </div>
      {isExpanded && <div className="space-y-4 pl-4 border-l-2 border-primary/20 ml-5" data-id="element-75">
          {posts.map((post, index) => <LocationPost key={index} {...post} data-id="element-76" />)}
        </div>}
    </div>;
};